/**
 * The lengths a service can be given (doc 45): a select instead of a minutes
 * box, so an owner picks "1 h 30 min" rather than typing 90 — and cannot type
 * 7 or 1000. Fine steps where they matter (5-minute steps up to an hour),
 * coarser ones for long services, then "all day".
 */

/** Stored for an all-day service: the 480 a reader without `allDay` still
 * understands as a long, valid service (see `ServiceSchema.allDay`). */
export const ALL_DAY_STORED_MIN = 480;
export const ALL_DAY = 'allDay';

export const DURATION_MINUTES: readonly number[] = [
  ...Array.from({ length: 12 }, (_, i) => (i + 1) * 5), // 5 … 60
  75, 90, 105, 120,
  ...Array.from({ length: 12 }, (_, i) => 150 + i * 30), // 2 h 30 … 8 h
];

export type DurationChoice = number | typeof ALL_DAY;

/** A stored service's value in the select. A legacy length that is not in the
 * list (an old typed 37) is kept as its own option, so editing a form never
 * silently changes it. */
export function durationOptions(current?: DurationChoice): DurationChoice[] {
  const list: DurationChoice[] = [...DURATION_MINUTES];
  if (typeof current === 'number' && !DURATION_MINUTES.includes(current)) {
    list.push(current);
    list.sort((a, b) => (a as number) - (b as number));
  }
  return [...list, ALL_DAY];
}

/** "45 min", "1 h", "1 h 30 min" — the parts, so the caller can translate. */
export function durationParts(min: number): { h: number; m: number } {
  return { h: Math.floor(min / 60), m: min % 60 };
}
